// @flow

import * as React from 'react';
import { Table } from 'antd'
import styles from './styles.css';
import Item from './Components/Item';
import moment from 'moment';

type Props = {
  project: {},
  activityFetching: boolean,
  activityPagination: {},
  componentDidMount: Function,
  onChangeTable: Function,
  onClickViewEmail: Function,
}

export default class extends React.PureComponent<Props> {

  componentDidMount = () => this.props.componentDidMount()

  render(){

    const {
      project,
      activityFetching,
      activityPagination,
      onChangeTable,
      onClickViewEmail
    } = this.props;

    const columns = [
      {
        title: 'Date',
        dataIndex: 'created_at',
        key: 'created_at',
        width: 150,
        sorter: false,
        render: (text) => moment(text).format('DD MMM YYYY HH:mm')
      },
      {
        title: 'User',
        dataIndex: 'causer',
        key: 'causer',
        width: 150,
        sorter: false,
        render: (causer) => causer && causer.first_name ? `${causer.first_name} ${causer.last_name || ''}`.trim() : 'System'
      },
      {
        title: 'Activity',
        dataIndex: 'description',
        key: 'description',
        sorter: false,
        render: (text, record) => (
          <Item item={record} onClickViewEmail={onClickViewEmail} inline />
        )
      },
    ];

    return(
      <div className={styles.wrapper}>
        <Table
          columns={columns}
          dataSource={project.audit_trail || []}
          rowKey='id'
          onChange={onChangeTable}
          bordered
          loading={activityFetching}
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            current: activityPagination.pageNumber,
            pageSize: activityPagination.pageSize,
            total: activityPagination.total,
          }}
        />
      </div>
    )
  }
}
